module.exports = __webpack_public_path__ + "images/src/components/Select/images/icon-chevron-down.41bf41146ae366789e1e.svg";